import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Component, inject, model } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { DeviceService } from '../../services/device.service';

@Component({
  selector: 'qwiko-dashboard-side-nav',
  imports: [CommonModule, RouterModule, TranslocoModule],
  templateUrl: './dashboard-side-nav.component.html',
  styleUrl: './dashboard-side-nav.component.scss',
})
export class DashboardSideNavComponent {
  deviceService = inject(DeviceService);
  sideNavIsOpen = model<boolean>(true);
}
